import React from "react";
import NewsSite from "./NewsSite";

const NewsSiteWidget = ({ layout, fontColor }) => {
  return <NewsSite layout={layout} fontColor={fontColor} />;
};

export default NewsSiteWidget;
